import React from "react";
import Plans from "../component/plan/Plans";
import SearchSection from "../component/search/SearchSection";
import AboutUs from "../component/aboutUs/AboutUs";
import { Helmet } from "react-helmet";
import WelcomeModal from "../component/common/WelcomeModal";

const HomePage =()=>{

    return(
        <div className="main_content">
            <Helmet>
            <link rel="canonical" href="/"/>
            <title>Truck & Trailer Repair Services | Online Road Services</title>
            <meta name="keywords" content="trailer repair shops, truck and trailer repair, truck repair near me, truck repair shops near me, semi trailer repair shop"/>
            <meta name="description" content="Get expert truck and trailer repair services with 24/7 roadside assistance. Fast &reliable support to keep you on the road. Call Online Road Services now!" />

            <meta property="og:title" content="Truck & Trailer Repair Services | Online Road Services" />
            <meta property="og:description" content="Get expert truck and trailer repair services with 24/7 roadside assistance. Fast &reliable support to keep you on the road. Call Online Road Services now!" />
           </Helmet>

            <WelcomeModal/>
            <SearchSection/>
            <AboutUs/>
            <Plans/>
        </div>
    );
};

export default HomePage;